import { Component, EventEmitter, Inject, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { process, State, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CommentService } from '../../services/comment.service';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { DataService } from '../../services/data.service';
import { EmailService } from '../../services/email.service';
import { EncryptionService } from '../../services/encryption.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { SendEmailDialog } from '../send-email-popup/send-email-popup.component';
import {
    Carrier
    , CarrierLane
    , CarrierLaneRank
    , CarrierList
    , CarrierLookup
    , CarrierService
    , City
    , Comment
    , ConvoyLoad
    , ConvoyResponse
    , CustomerCarrierExclusionMap
    , Email
    , Employee
    , EquipmentClass
    , GreenscreensLaneRatePrediction
    , QuoteOrder
    , QuoteOrderLine
    , SearchCarrier
    , SearchCarrierContact
    , SearchCarrierListCriteria
    , SearchCarrierSalesAvailableLoads
    , SearchCarrierSalesAvailableLoadsFilter
    , SearchOrderStop
    , SearchQuoteOrderLine
    , SearchTrailerEquipmentClass
    , Zip3
} from '../../models/models';
//import { environment } from '../../../environments/environment';

@Component({
    selector: 'carrier-list-grid',
    templateUrl: './carrier-list-grid.component.html',
    standalone: false
})
export class CarrierListGrid implements OnInit, OnChanges {
    //@ViewChild("offerRate", { static: false }) offerRateField: ElementRef | undefined;
    @Input() quoteOrderLineID: number = 0;
    @Input() originalQuoteOrderLineID: number = 0;
    @Input() loads: SearchCarrierSalesAvailableLoads[] = [];
    @Input() availableLoadsFilter: SearchCarrierSalesAvailableLoadsFilter = {} as SearchCarrierSalesAvailableLoadsFilter;
    @Input() viewType: string = "";
    @Input() bulkTenderLoads: SearchCarrierSalesAvailableLoads[] = [];
    @Input() employees: Employee[] = [];
    @Input() refreshDate: Date = new Date();
    //@Output() onClick = new EventEmitter<any>();
    @Output() onCarrierClick = new EventEmitter<any>();
    @Output() onBulkTenderOfferSave = new EventEmitter<any>();
    @Output() refreshData = new EventEmitter<any>();
    @Output() updateEditedLoad = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public carriersGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public carriersSearchGrid!: GridComponent;
    @ViewChild(TabStripComponent, { static: false }) public tabStrip!: TabStripComponent;

    private subSearchQuoteOrderLine: Subscription | undefined;
    private tabNum: number = 0;
    public carriersOrig: CarrierList[] = [];
    public carriers: CarrierList[] = [];
    public searchCarriers: CarrierList[] = [];
    public carrierLookupList: CarrierLookup[] = [];
    public ccEmails: Email[] = [];
    public carrier: SearchCarrier = {} as SearchCarrier;
    public carrierOffer: CarrierList = {} as CarrierList;
    public customerCarrierExclusionMapList: CustomerCarrierExclusionMap[] = [];
    public searchTrailerEquipmentClassList: SearchTrailerEquipmentClass[] = [];
    public filteredTrailerEquipmentClassList: SearchTrailerEquipmentClass[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public carrierServiceList: CarrierService[] = [];
    private originalLoad: SearchCarrierSalesAvailableLoads = {} as SearchCarrierSalesAvailableLoads;
    public quoteOrder: QuoteOrder = {} as QuoteOrder;
    public quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    public searchQuoteOrderLine: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    private originCity: City = {} as City;
    private destinationCity: City = {} as City;
    private searchStops: SearchOrderStop[] = [];
    public gsRate: GreenscreensLaneRatePrediction = {} as GreenscreensLaneRatePrediction;
    public convoyLoad: ConvoyLoad = {} as ConvoyLoad;
    public convoyResponse: ConvoyResponse = {} as ConvoyResponse;
    public isShowConvoyLoadError: boolean = false;
    public notes: Comment = {} as Comment;
    public remarks: Comment = {} as Comment;
    //public offers: Observable<Offer[]> = new Observable<Offer[]>();
    public isExcludeNonRMISCertified: boolean = true;
    public isBulkTender: boolean = false;
    public isAddCarrier: boolean = false;
    public isSaving: boolean = false;
    public isCustomerExcluded: boolean = false;
    private carrierOfferBatchID: number = -1;
    private carrierID: number = 0;
    public geocodeLaneID: number = 0;
    public min: number = 1;
    public max: number = 4;
    public originSliderValue: number = 1;
    public destinationSliderValue: number = 1;
    private filteredCarriers: CarrierList[] = [];
    private filteredSearchCarriers: CarrierList[] = [];
    public originZip3: Zip3 = {} as Zip3;
    public destinationZip3: Zip3 = {} as Zip3;
    private expandedOriginMarkets: string[] = [];
    private expandedDestinationMarkets: string[] = [];
    private editedRowIndex: number | undefined;
    private editedCarrierList: CarrierList = {} as CarrierList;
    private bulkTenderCarrierList: CarrierList[] = [];
    private expandedOriginFilter: boolean = false;
    private expandedDestinationFilter: boolean = false;
    public rankList: CarrierLaneRank[] = [];
    public carrierLookupType: string = "MC";
    public carrierLookupControl = new UntypedFormControl();
    public countryCode: string = "US";

    public convoyMaxBuyRate: number = 0;
    public convoyAutoAcceptRate: number = 0;

    public searchCarrierListCriteria: SearchCarrierListCriteria = {
        domiciledOrigin: "",
        domiciledOriginID: "",
        domiciledDestination: "",
        domiciledDestinationID: "",
        equipmentClassID: 0,
        trailerIDs: "",
        serviceID: 0,
        serviceIDs: ""
    }
    public equipmentClassID: number = 0;
    public carrierServiceID: number = 0;

    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'confidenceRanking' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    public searchGridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'confidenceRanking' }] };
    public searchGridData: GridDataResult = { data: [], total: 0 };

    carrierFormGroup: UntypedFormGroup = new UntypedFormGroup({
        carrierLookupControl: new UntypedFormControl('')
    });

    constructor(private applicationControlService: ApplicationControlService, private cityService: CityService,
        private commentService: CommentService, private contactService: ContactService, private cseService: CSEService,
        private dataService: DataService, private encryptionService: EncryptionService, private emailService: EmailService,
        private notificationService: NotificationService, private orderService: OrderService, public utilService: UtilService,
        public dialog: MatDialog, private ngZone: NgZone, @Inject('BASE_URL') private baseUrl: string) {
        this.applicationControlService.getApplicationControlsByAppName("IsExcludeNonRMISCertified", false).subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                if (appValue == "1") {
                    this.isExcludeNonRMISCertified = true;
                }
                else {
                    this.isExcludeNonRMISCertified = false;
                }
            }
        });
    }

    ngOnInit() {
        //this.initValues();
        //this.getQuoteOrderLine();
        //console.log("ngOnInit");
        //this.cseService.getOffersByLineId(this.quoteOrderLineID);
        //this.offers = this.cseService.offers;
        this.getEquipmentClasses();
        this.getSearchTrailerEquipmentClass();
        this.getGetCarrierServices();
        //console.log("carrier-list-grid:ngOnInit", this.bulkTenderLoads, this.isBulkTender, this.originalQuoteOrderLineID, this.editedCarrierList);
    }

    ngOnChanges() {
        this.resetCarrierRanks();
        this.initValues();
        this.getQuoteOrderLine();
        //if (this.offerRateField) {
        //    this.offerRateField.nativeElement.focus();
        //}
        //this.getZip3();
        //console.log("carrier-list-grid:ngOnChanges", this.bulkTenderLoads, this.isBulkTender, this.originalQuoteOrderLineID, this.editedCarrierList);
        //console.log("carrier-list-grid:ngOnChanges", this.viewType);
    }

    ngAfterViewInit() {
    //    this.offerRateField.nativeElement.focus();
    }

    private initValues() {
        this.carrierLookupType = "MC";
        this.originSliderValue = 1;
        this.destinationSliderValue = 1;
        this.isBulkTender = (this.bulkTenderLoads.length > 0);
    }

    private getQuoteOrderLine() {
        this.utilService.isLoading = true;
        this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(this.quoteOrderLineID);
        if (this.quoteOrderLineID == this.originalQuoteOrderLineID) {
            var idx = this.loads.findIndex(t => t.quoteOrderLineID == this.quoteOrderLineID);
            if (idx >= 0) {
                this.originalLoad = Object.assign({}, this.loads[idx]);
                //console.log("getQuoteOrderLine:originalLoad", this.originalQuoteOrderLineID, this.originalLoad);
            }
        }
        this.getSearchQuoteOrderLine();
        this.cseService.getQuoteOrderLineById(this.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            this.quoteOrderLine = result;
            this.getGreenscreensLaneRatePredictionByQuoteOrderLineID();
            this.getConvoyLoadByQuoteOrderLineID();
            this.getComments();
            this.getCustomerCarrierExclusionMap();
            if (this.originalQuoteOrderLineID > 0 && this.originalQuoteOrderLineID != this.quoteOrderLineID) {
                if (this.tabNum != 2) {
                    this.tabStrip.selectTab(2);
                }
            }
            else if (this.isBulkTender) {
                //this.tabStrip.selectTab(4);
            }
            else {
                this.getCarriers();
            }
            //console.log("carrier-list-grid:getQuoteOrderLine", this.quoteOrderLineID, this.originalQuoteOrderLineID, this.editedCarrierList);
        });
    }

    private getSearchQuoteOrderLine() {
        var name = "getSearchQuoteOrderLineByQuoteOrderLineID-" + this.quoteOrderLineID;
        if (this.subSearchQuoteOrderLine) {
            this.subSearchQuoteOrderLine.unsubscribe();
        }
        var data = this.dataService.get(name);
        if (data) {
            this.utilService.isLoading = false;
            this.searchQuoteOrderLine = data.resultCollection[0];
            this.getCities();
            this.getQuoteOrder();
            //console.log("offerList", this.offerList);
        }
        else {
            this.subSearchQuoteOrderLine = this.dataService.currentDataCollection.subscribe(result => {
                this.utilService.isLoading = false;
                if (result.name == name) {
                    this.searchQuoteOrderLine = result.resultCollection[0];
                    this.getCities();
                    this.getQuoteOrder();
                    //console.log("offerList", this.offerList);
                }
            });
        }
    }

    private getSearchOrderStops(quoteOrderLineID: number) {
        this.utilService.isLoading = true;
        this.orderService.getSearchOrderStopsByQuoteOrderLineID(quoteOrderLineID).subscribe(result => {
            this.searchStops = result.resultCollection;
        });
    }

    private getGreenscreensLaneRatePredictionByQuoteOrderLineID() {
        this.utilService.isLoading = true;
        this.orderService.getGreenscreensLaneRatePredictionByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.gsRate = result.resultCollection[0];
                this.setGreenscreesRate();
            }
            else {
                this.gsRate = {} as GreenscreensLaneRatePrediction;
            }
        });
    }

    private getCities() {
        this.utilService.isLoading = true;
        this.cityService.getCityByID(this.searchQuoteOrderLine.originCityID!).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.originCity = result.resultCollection[0];
            }
            else {
                this.originCity = {} as City;
            }
        });
        this.cityService.getCityByID(this.searchQuoteOrderLine.destinationCityID!).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.destinationCity = result.resultCollection[0];
            }
            else {
                this.destinationCity = {} as City;
            }
        });
    }

    private getConvoyLoadByQuoteOrderLineID() {
        this.utilService.isLoading = true;
        this.orderService.getConvoyLoadByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.convoyLoad = result.resultCollection[0];
                if (this.convoyLoad != null) {
                    if (this.convoyLoad.maxBuyRateCents > 0) {
                        this.convoyMaxBuyRate = this.convoyLoad.maxBuyRateCents / 100;
                    }
                    if (this.convoyLoad.autoAcceptRateCents > 0) {
                        this.convoyAutoAcceptRate = this.convoyLoad.autoAcceptRateCents / 100;
                    }
                }
                else {
                    this.convoyLoad = {} as ConvoyLoad;
                }
            }
            else {
                this.convoyLoad = {} as ConvoyLoad;
            }
        });
    }

    public canShowConvoy() {
        var canShow = true;
        if (this.searchQuoteOrderLine.loadStatus != "Available") {
            canShow = false;
        }
        if (this.searchQuoteOrderLine.isMexicoOnly) {
            canShow = false;
        }
        var usStops = this.searchStops.filter(t => t.countryAbbr == "US");
        if (this.searchStops.length != usStops.length) {
            // Not all US stops
            canShow = false;
        }
        var idx = this.equipmentClassList.findIndex(t => t.abbreviation == this.searchQuoteOrderLine.equipmentClassAbbrev && t.convoyEquipmentType != null);
        if (idx < 0) {
            canShow = false;
        }
        return canShow;
    }

    public canCancelConvoy() {
        var canCancel = false;
        if (this.convoyLoad.loadSyncID != null && this.convoyLoad.loadSyncID != "" && this.convoyLoad.postingStatus != "CANCELED") {
            canCancel = true;
        }
        return canCancel;
    }

    public canUncancelConvoy() {
        var canUncancel = false;
        if (this.convoyLoad.loadSyncID != null && this.convoyLoad.loadSyncID != "" && this.convoyLoad.postingStatus == "CANCELED") {
            canUncancel = true;
        }
        return canUncancel;
    }

    public viewConvoyError() {
        this.isShowConvoyLoadError = !this.isShowConvoyLoadError;
        var json = JSON.parse(this.convoyLoad.jsonResponse);
        var loads = json.loads;
        this.convoyResponse = {
            loads: loads
        };
        if (this.convoyResponse.loads!.length > 0) {
            this.convoyResponse.loads![0].errors = JSON.stringify(loads[0].errors);
        }
    }

    public updateConvoy() {
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        var maxBuyRateCents = this.convoyMaxBuyRate * 100;
        var autoAcceptRateCents = this.convoyAutoAcceptRate * 100;
        this.utilService.isLoading = true;
        this.orderService.updateConvoyLoadByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID, maxBuyRateCents, autoAcceptRateCents, employeeID).subscribe(result => {
            this.utilService.isLoading = false;
            console.log("updateConvoy", result);

            if (result.resultCollection.length > 0) {
                this.convoyLoad = result.resultCollection[0];
            }
            else {
                this.convoyLoad = {} as ConvoyLoad;
            }
        });
    }

    public cancelConvoy() {
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.utilService.isLoading = true;
        this.orderService.cancelConvoyLoadByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID, employeeID).subscribe(result => {
            this.utilService.isLoading = false;
            console.log("cancelConvoy", result);

            if (result.resultCollection.length > 0) {
                this.convoyLoad = result.resultCollection[0];
            }
            else {
                this.convoyLoad = {} as ConvoyLoad;
            }
        });
    }

    public uncancelConvoy() {
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.utilService.isLoading = true;
        this.orderService.uncancelConvoyLoadByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID, employeeID).subscribe(result => {
            this.utilService.isLoading = false;
            console.log("uncancelConvoy", result);

            if (result.resultCollection.length > 0) {
                this.convoyLoad = result.resultCollection[0];
            }
            else {
                this.convoyLoad = {} as ConvoyLoad;
            }
        });
    }

    public updateGreenscreens() {
        this.utilService.isLoading = true;
        this.orderService.updateGreenscreensLaneRatePredictionByQuoteOrderLineID(this.searchQuoteOrderLine.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            console.log("updateGreenscreens", result);

            if (result.resultCollection.length > 0) {
                this.gsRate = result.resultCollection[0];
                this.setGreenscreesRate();
            }
            else {
                this.gsRate = {} as GreenscreensLaneRatePrediction;
            }
        });
    }

    private setGreenscreesRate() {
        var dist = (this.gsRate.distance != null ? this.gsRate.distance : 0);
        if (this.gsRate.targetBuyRate != null) {
            this.gsRate.targetBuyRate = this.gsRate.targetBuyRate * dist;
        }
        if (this.gsRate.startBuyRate != null) {
            this.gsRate.startBuyRate = this.gsRate.startBuyRate * dist;
        }
        this.gsRate.createdDate = new Date(this.gsRate.createdDate);
    }

    private getQuoteOrder() {
        this.orderService.getQuoteOrderByID(this.searchQuoteOrderLine.quoteOrderID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.quoteOrder = result.resultCollection[0];
            }
            else {
                this.quoteOrder = {} as QuoteOrder;
            }
        });
    }

    private getZip3() {
        this.cseService.getZip3sByLineId(this.quoteOrderLineID).subscribe(result => {
            this.originZip3 = result[0];
            this.destinationZip3 = result[1];
            this.expandedOriginMarkets = this.originZip3.expandedMarketZip3List.split(',');
            this.expandedDestinationMarkets = this.destinationZip3.expandedMarketZip3List.split(',');
        });
    }

    private getCustomerCarrierExclusionMap() {
        this.utilService.isLoading = true;
        this.cseService.getCustomerCarrierExclusionMapByCustomerID(this.searchQuoteOrderLine.billToCustomerID).subscribe(result => {
            this.customerCarrierExclusionMapList = result.resultCollection;
            this.utilService.isLoading = false;
        });
    }

    private getEquipmentClasses() {
        this.utilService.isLoading = true;
        this.cseService.getEquipmentClasses().subscribe(result => {
            this.equipmentClassList = result.resultCollection;
            this.utilService.isLoading = false;
        });
    }

    private getSearchTrailerEquipmentClass() {
        this.utilService.isLoading = true;
        this.cseService.getSearchTrailerEquipmentClass().subscribe(result => {
            this.searchTrailerEquipmentClassList = result.resultCollection;
            this.searchTrailerEquipmentClassList = this.searchTrailerEquipmentClassList.filter(t => t.allowedOnLanes == true);
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
            this.utilService.isLoading = false;
        });
    }

    private getGetCarrierServices() {
        this.cseService.getAllCarrierServices().subscribe(result => {
            this.carrierServiceList = result;
        });
    }

    public domiciledChange(evt: any, domiciledType: string) {
        if (domiciledType == "origin") {
            this.searchCarrierListCriteria.domiciledDestination = "";
            this.searchCarrierListCriteria.domiciledDestinationID = "";
        }
        else if (domiciledType == "destination") {
            this.searchCarrierListCriteria.domiciledOrigin = "";
            this.searchCarrierListCriteria.domiciledOriginID = "";
        }
    }

    public equipmentClassChange(evt: any) {
        var id = evt.target ? evt.target.value : evt;
        this.searchTrailerEquipmentClassList.forEach(t => {
            t.isChecked = false;
        });
        if (id > 0) {
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
            this.filteredTrailerEquipmentClassList = this.filteredTrailerEquipmentClassList.filter(t => t.equipmentClassID == id);
            this.filteredTrailerEquipmentClassList.forEach(t => {
                t.isChecked = true;
            });
        }
        else {
            this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
        }
        //console.log("equipmentClassChange", evt);
    }

    private getCarriers() {
        this.utilService.isLoading = true;
        this.cseService.getCarriersByQuoteOrderLineIDGeocodeLaneID(this.quoteOrderLineID, this.geocodeLaneID).subscribe(result => {
            this.utilService.isLoading = false;
            this.carriersOrig = result;
            this.getRankTotals();
            this.setCarrierFilter();
            //this.tabStrip.selectTab(0);
            //console.log("carriers", this.carriers.length);
        });
    }

    private getCarrierDetailForOffer(carrierID: number) {
        this.utilService.isLoading = true;
        this.cseService.getCarriersByQuoteOrderLineIDGeocodeLaneID(this.quoteOrderLineID, this.geocodeLaneID).subscribe(result => {
            this.utilService.isLoading = false;
            var list: CarrierList[] = result;
            var carrier = list.find(t => t.carrierId == carrierID);
            if (carrier) {
                this.editedCarrierList = Object.assign({}, carrier);
            }
            else {
                this.getCarrierOfferFromCarrier();
            }
        //    console.log("carrier-list-grid:getCarrierDetailForOffer"
        //        , "this.originalQuoteOrderLineID", this.originalQuoteOrderLineID
        //        , "this.carrierID", this.carrierID
        //        , "this.carrierOfferBatchID", this.carrierOfferBatchID
        //        , "this.editedCarrierList!.carrierOfferBatchId", this.editedCarrierList!.carrierOfferBatchId
        //        , "this.editedCarrierList", this.editedCarrierList
        //        , "carrier", carrier);
        });
    }

    public getSearchCarrierList() {
        this.utilService.isLoading = true;

        //this.searchCarriers.length = 0;
        //this.filteredSearchCarriers.length = 0;

        if (this.searchCarrierListCriteria.domiciledOrigin == "Zip3") {
            this.searchCarrierListCriteria.domiciledOriginID = this.originCity.zip3;
        }
        else if (this.searchCarrierListCriteria.domiciledOrigin == "Market") {
            this.searchCarrierListCriteria.domiciledOriginID = this.originCity.marketID.toString();
        }
        else if (this.searchCarrierListCriteria.domiciledOrigin == "Expanded Market") {
            this.searchCarrierListCriteria.domiciledOriginID = this.originCity.zip3;
        }
        else if (this.searchCarrierListCriteria.domiciledOrigin == "Region") {
            this.searchCarrierListCriteria.domiciledOriginID = this.originCity.regionID.toString();
        }

        if (this.searchCarrierListCriteria.domiciledDestination == "Zip3") {
            this.searchCarrierListCriteria.domiciledDestinationID = this.destinationCity.zip3;
        }
        else if (this.searchCarrierListCriteria.domiciledDestination == "Market") {
            this.searchCarrierListCriteria.domiciledDestinationID = this.destinationCity.marketID.toString();
        }
        else if (this.searchCarrierListCriteria.domiciledDestination == "Expanded Market") {
            this.searchCarrierListCriteria.domiciledDestinationID = this.destinationCity.zip3;
        }
        else if (this.searchCarrierListCriteria.domiciledDestination == "Region") {
            this.searchCarrierListCriteria.domiciledDestinationID = this.destinationCity.regionID.toString();
        }

        var equipmentIDs: number[] = [];
        this.filteredTrailerEquipmentClassList.forEach(t => {
            if (t.isChecked == true) {
                equipmentIDs.push(t.trailerTypeID);
            }
        });

        var serviceIDs: number[] = [];
        this.carrierServiceList.forEach(t => {
            if (t.isChecked == true) {
                serviceIDs.push(t.carrierServiceID);
            }
        });

        this.searchCarrierListCriteria.trailerIDs = equipmentIDs.join(",");
        this.searchCarrierListCriteria.serviceIDs = serviceIDs.join(",");

        //var criteria: SearchCarrierListCriteria = {
        //    domiciledOrigin: "",
        //    domiciledOriginID: "",
        //    domiciledDestination: "",
        //    domiciledDestinationID: "",
        //    equipmentClassID: 0,
        //    trailerIDs: "",
        //    serviceID: 0,
        //    serviceIDs: "10,11"
        //}
        this.cseService.getSearchCarrierList(this.searchCarrierListCriteria).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCarriers = result.resultCollection;
            //this.getRankTotals();
            //this.setSearchCarrierFilter();
            this.setSearchGrid();
            //this.tabStrip.selectTab(0);
            //console.log("searchCarriers", this.searchCarrierListCriteria, this.searchCarriers.length, this.searchCarriers);
        });
    }

    public clearSearchCarrierList() {
        this.searchCarrierListCriteria.domiciledOrigin = "";
        this.searchCarrierListCriteria.domiciledDestination = "";
        this.equipmentClassID = 0;
        //this.equipmentClassChange(0);
        this.filteredTrailerEquipmentClassList = Object.assign([], this.searchTrailerEquipmentClassList);
        this.filteredTrailerEquipmentClassList.forEach(t => {
            t.isChecked = false;
        });

        this.carrierServiceID = 0;
        this.carrierServiceList.forEach(t => {
            t.isChecked = false;
        });
        this.searchCarriers.length = 0;
        this.setSearchGrid();
    }

    public getCarrierLookup(type) {
        this.carrierLookupType = type;
    }

    public addCarrier() {
        this.isAddCarrier = true;
    }

    //public checkCarrierLookupValue() {
    //    console.log("checkCarrierLookupValue", this.carrierFormGroup.controls['carrierLookupControl'].value);
    //}

    public getDATCarrierByNumber() {
        var datNumber = this.carrierFormGroup.controls['carrierLookupControl'].value;
        //console.log("getDATCarrierByNumber", datNumber, this.carrierFormGroup.controls['carrierLookupControl'].value);
        this.utilService.isLoading = true;
        if (this.carrierLookupType == "MC") {
            this.cseService.getDATCarrierByMCNumber(datNumber).subscribe(result => {
                this.utilService.isLoading = false;
                var carrier: Carrier = result.resultCollection[0];
                //console.log("getDATCarrierByMCNumber", datNumber, carrier);
                //this.carrierFormGroup.controls['carrierLookupControl'].setValue(carrier);
                //this.editedCarrierList = Object.assign({}, carrier);
                this.onCarrierChange(carrier.carrierID);
            });
        }
        else if (this.carrierLookupType == "DOT") {
            this.cseService.getDATCarrierByDOTNumber(datNumber).subscribe(result => {
                this.utilService.isLoading = false;
                var carrier: Carrier = result.resultCollection[0];
                //console.log("getDATCarrierByDOTNumber", datNumber, carrier);
                //this.carrierFormGroup.controls['carrierLookupControl'].setValue(carrier);
                //this.editedCarrierList = Object.assign({}, carrier);
                this.onCarrierChange(carrier.carrierID);
            });
        }
    }

    public isDATLookup() {
        var isLookup = false;
        if (this.carrierLookupType == "MC" || this.carrierLookupType == "DOT") {
            var datNumber = this.carrierFormGroup.controls['carrierLookupControl'].value;
            if (datNumber && datNumber != null && /^-?\d+$/.test(datNumber)) {
                var str = JSON.stringify(datNumber);
                if (str.length > 1 && str.length < 50) {
                    isLookup = true;
                }
                //console.log("isDATLookup", datNumber, str);
            }
        }
        return isLookup;
    }

    public onTabSelect(evt: any) {
        //console.log("onTabSelect", evt, this.editedCarrierList, this.carrierOffer);
        this.tabNum = evt.index;
        if (evt.title == "Carrier Lookup") {
            //this.getCarrierLookupList();
            this.editedCarrierList = {} as CarrierList;
        }
        else if (evt.title == "Carriers by Geocode") {
            this.editedCarrierList = {} as CarrierList;
            this.carrier = {} as SearchCarrier;
            this.carrierOffer = {} as CarrierList;
            //this.originalQuoteOrderLineID = 0;
        }
        else {
            this.carrier = {} as SearchCarrier;
            this.carrierOffer = {} as CarrierList;
        }
        //if (this.offerRateField) {
        //    this.offerRateField.nativeElement.focus();
        //}
        //this.getCarrierLookupList();
        //console.log("carrier-list-grid:onTabSelect", evt.title, this.originalQuoteOrderLineID, this.editedCarrierList);
    }

    private getRankTotals() {
        var overZero = 0;
        var total = 0;
        for (var i = 0; i < this.rankList.length; i++) {
            total = this.carriersOrig.filter(c => c.confidenceRanking == this.rankList[i].rank).length;
            this.rankList[i].total = total;
            if (total > 0 && overZero < 3) {
                this.rankList[i].isShow = true;
                overZero++;
            }
        }
    }

    public toggleRank(rank: CarrierLaneRank) {
        //var idx = this.rankList.findIndex(r => r.rank == rank.rank);
        rank.isShow = !rank.isShow;
        //this.rankList[idx].isShow = rank.isShow;
        this.filterRanks();
        this.setGrid();
        //console.log("toggleRank", rank, this.carriers.length, this.rankList);
    }

    private resetCarrierRanks() {
        //console.log("resetCarrierRanks");
        this.rankList = [
            { rank: 0, rankAbbrev: "RanBefore", rankName: "Ran Before", total: 0, isShow: false },
            { rank: 1, rankAbbrev: "OZipToDZip", rankName: "Zip to Zip", total: 0, isShow: false },
            { rank: 2, rankAbbrev: "OZipToDMkt", rankName: "Zip to Mkt", total: 0, isShow: false },
            { rank: 3, rankAbbrev: "OZipToDExpMkt", rankName: "Zip to X-Mkt", total: 0, isShow: false },
            { rank: 4, rankAbbrev: "OZipToDReg", rankName: "Zip to Reg", total: 0, isShow: false },
            { rank: 5, rankAbbrev: "OMktToDZip", rankName: "Mkt to Zip", total: 0, isShow: false },
            { rank: 6, rankAbbrev: "OMktToDMkt", rankName: "Mkt to Mkt", total: 0, isShow: false },
            { rank: 7, rankAbbrev: "OMktToDExpMkt", rankName: "Mkt to X-Mkt", total: 0, isShow: false },
            { rank: 8, rankAbbrev: "OMktToDReg", rankName: "Mkt to Reg", total: 0, isShow: false },
            { rank: 9, rankAbbrev: "OExpMktToDZip", rankName: "X-Mkt to Zip", total: 0, isShow: false },
            { rank: 10, rankAbbrev: "OExpMktToDMkt", rankName: "X-Mkt to Mkt", total: 0, isShow: false },
            { rank: 11, rankAbbrev: "OExpMktToDExpMkt", rankName: "X-Mkt to X-Mkt", total: 0, isShow: false },
            { rank: 12, rankAbbrev: "OExpMktToDReg", rankName: "X-Mkt to Reg", total: 0, isShow: false },
            { rank: 13, rankAbbrev: "ORegToDZip", rankName: "Reg to Zip", total: 0, isShow: false },
            { rank: 14, rankAbbrev: "ORegToDMkt", rankName: "Reg to Mkt", total: 0, isShow: false },
            { rank: 15, rankAbbrev: "ORegToDExpMkt", rankName: "Reg to X-Mkt", total: 0, isShow: false },
            { rank: 16, rankAbbrev: "ORegToDReg", rankName: "Reg to Reg", total: 0, isShow: false }
        ];
    }

    private filterRanks() {
        this.carriers = Object.assign([], this.carriersOrig);

        for (var i = 0; i < this.rankList.length; i++) {
            if (!this.rankList[i].isShow) {
                this.carriers = this.carriers.filter(c => c.confidenceRanking != this.rankList[i].rank);
            }
        }
    }

    private setGrid() {
        this.filteredCarriers = Object.assign([], this.carriers);

        //if (this.originSliderValue == 3 && this.destinationSliderValue != 3) {
        //    this.filteredCarriers = this.filteredCarriers.filter(c => this.expandedOriginMarkets.indexOf(c.originMarketId.toString()) > -1);
        //}

        //if (this.destinationSliderValue == 3) {
        //    this.gridState.filter = { filters: [], logic: 'and' };
        //    this.filteredCarriers = this.filteredCarriers.filter(c => this.expandedDestinationMarkets.indexOf(c.destinationMarketId.toString()) > -1);
        //}

        this.gridData = process(this.filteredCarriers, this.gridState);
        //console.log("setGrid", this.gridData, this.filteredCarriers);

        this.fitColumns();
    }

    private setSearchGrid() {
        this.filteredSearchCarriers = Object.assign([], this.searchCarriers);
        this.searchGridData = process(this.filteredSearchCarriers, this.searchGridState);

        this.fitCarriersSearchColumns();
        //console.log("setSearchGrid", this.searchGridData, this.filteredSearchCarriers);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carriersGrid == null) return;
            this.carriersGrid.autoFitColumns();
        });
    }

    private fitCarriersSearchColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carriersSearchGrid == null) return;
            this.carriersSearchGrid.autoFitColumns();
        });
    }

    public rowCallback(context: RowClassArgs) {
        const isHardContact = (context.dataItem.hardContact == true);
        const isSoftContacted = (context.dataItem.softContacted == true);
        if (isHardContact) {
            return {
                success: isHardContact
            }
        }
        else if (isSoftContacted) {
            return {
                warning: isSoftContacted
            }
        }
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.carriers, this.gridState);
        this.fitColumns();
    }

    public searchDataStateChange(state: DataStateChangeEvent): void {
        this.searchGridState = state;
        this.searchGridData = process(this.searchCarriers, this.searchGridState);
        this.fitCarriersSearchColumns();
    }

    private setCarrierFilter() {
        //this.gridState.filter = {
        //    filters: [
        //        {
        //            field: 'originZip3',
        //            operator: 'contains',
        //            value: this.originCity.zip3
        //        },
        //        {
        //            field: 'destinationZip3',
        //            operator: 'contains',
        //            value: this.destinationCity.zip3
        //        }
        //    ],
        //    logic: 'and'
        //} as CompositeFilterDescriptor;

        this.filterRanks();

        if (this.carriers.length > 0) this.setGrid();
    }

    //private setSearchCarrierFilter() {
    //    if (this.searchCarriers.length > 0) this.setSearchGrid();
    //}

    public sliderTitle(value: number): string {
        var sliderText = '';

        switch (value) {
            case 1:
                sliderText = 'Zip 3';
                break;
            case 2:
                sliderText = 'Mkt';
                break;
            case 3:
                sliderText = 'X-Mkt';
                break;
            case 4:
                sliderText = 'Reg';
                break;
        }

        return sliderText;
    }

    public sliderValueChanged() {
        this.expandedOriginFilter = false;
        this.expandedDestinationFilter = false;
        this.gridState.filter = { filters: [], logic: 'and' } as CompositeFilterDescriptor;

        switch (this.originSliderValue) {
            case 1:
                this.gridState.filter.filters.push({
                    field: 'originZip3',
                    operator: 'contains',
                    value: this.originCity.zip3
                });
                break;
            case 2:
                this.gridState.filter.filters.push({
                    field: 'originMarketId',
                    operator: 'eq',
                    value: this.originCity.marketID
                });
                break;
            case 3:
                this.expandedOriginFilter = true;
                break;
            case 4:
                this.gridState.filter.filters.push({
                    field: 'originRegionId',
                    operator: 'eq',
                    value: this.originCity.regionID
                });
                break;
        }

        switch (this.destinationSliderValue) {
            case 1:
                this.gridState.filter.filters.push({
                    field: 'destinationZip3',
                    operator: 'eq',
                    value: this.destinationCity.zip3
                });
                break;
            case 2:
                this.gridState.filter.filters.push({
                    field: 'destinationMarketId',
                    operator: 'eq',
                    value: this.destinationCity.marketID
                });
                break;
            case 3:
                this.expandedDestinationFilter = true;
                break;
            case 4:
                this.gridState.filter.filters.push({
                    field: 'destinationRegionId',
                    operator: 'eq',
                    value: this.destinationCity.regionID
                });
                break;
        }

        if (this.carriers.length > 0) this.setGrid();
        //console.log("sliderValueChanged", this.originSliderValue, this.destinationSliderValue, this.quoteOrderLine);
    }

    public calculateOfferRate(offerRatePerMile: number) {
        if (this.quoteOrderLine.miles > 0) {
            return parseFloat((offerRatePerMile * this.quoteOrderLine.miles).toFixed(2));
        }
        //console.log("calculateRate", offerRatePerMile, this.quoteOrderLine.miles);
    }

    public calculateOfferRatePerMile(offerRate: number) {
        if (this.quoteOrderLine.miles > 0) {
            return parseFloat((offerRate / this.quoteOrderLine.miles).toFixed(2));
        }
        //console.log("calculateRate", offerRate, this.quoteOrderLine.miles);
    }

    public calculateFuelCost(fuelCostPerMile: number) {
        if (this.quoteOrderLine.miles > 0) {
            return parseFloat((fuelCostPerMile * this.quoteOrderLine.miles).toFixed(2));
        }
        //console.log("calculateRate", fuelCostPerMile, this.quoteOrderLine.miles);
    }

    public calculateFuelCostPerMile(fuelCost: number) {
        if (this.quoteOrderLine.miles > 0) {
            return parseFloat((fuelCost / this.quoteOrderLine.miles).toFixed(2));
        }
        //console.log("calculateRate", fuelCost, this.quoteOrderLine.miles);
    }

    private getComments() {
        if (this.quoteOrderLine != null) {
            if (this.quoteOrderLine.commentId > 0) {
                this.commentService.getCommentById(this.quoteOrderLine.commentId).subscribe(result => {
                    this.remarks = result;
                });
            } else {
                this.remarks = {} as Comment;
            }

            if (this.quoteOrderLine.internalCommentId > 0) {
                this.commentService.getCommentById(this.quoteOrderLine.internalCommentId).subscribe(result => {
                    this.notes = result;
                });
            } else {
                this.notes = {} as Comment;
            }
        }
    }

    public saveQuoteOrderNotes() {
        this.utilService.isLoading = true;
        this.quoteOrder.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.orderService.saveQuoteOrderNotes(this.quoteOrder).subscribe(result => {
            this.utilService.isLoading = false;
            //console.log("saveQuoteOrderNotes", result, this.quoteOrder);
        });
    }

    public saveQuoteOrderLineComments() {
        this.saveComment(this.notes, "notes");
        this.saveComment(this.remarks, "remarks");
    }

    public saveComment(comment: Comment, commentType: string) {
        if (comment == null || comment.commentText == undefined || comment.commentText.length < 1) return;

        this.utilService.isLoading = true;
        this.commentService.saveComment(comment).subscribe(result => {
            if (commentType == "notes") {
                this.quoteOrderLine.internalCommentId = result.commentId;
                this.orderService.saveQuoteOrderLine(this.quoteOrderLine).subscribe(result => {
                    //console.log("saveQuoteOrderLine", result);
                });
            }
            else if (commentType == "remarks") {
                this.quoteOrderLine.commentId = result.commentId;
                this.orderService.saveQuoteOrderLine(this.quoteOrderLine).subscribe(result => {
                    //console.log("saveQuoteOrderLine", result);
                });
            }
            //console.log("saveComment", comment, result);
            this.utilService.isLoading = false;
        });
    }

    public editHandler({ sender, rowIndex, dataItem }) {
        //console.log("editHandler", dataItem);
        //this.carriersGrid = sender;
        this.closeEditor(sender);
        this.onCarrierClick.emit(dataItem.carrierId);

        if (dataItem.offerId == 0) {
            this.orderService.getOfferByLineIdCarrierId(dataItem.quoteOrderLineId, dataItem.carrierId).subscribe(result => {
                if (result != null) {
                    // Offer already exists
                    this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
                }
                else {
                    this.editedRowIndex = rowIndex;
                    this.editedCarrierList = Object.assign({}, dataItem);
                    this.carrierID = this.editedCarrierList!.carrierId;
                    sender.editRow(rowIndex);
                    this.tabStrip.selectTab(2);
                }
            });
        }
        else {
            this.editedRowIndex = rowIndex;
            this.editedCarrierList = Object.assign({}, dataItem);
            this.carrierID = this.editedCarrierList!.carrierId;
            sender.editRow(rowIndex);
        }
    }

    public addOffer(dataItem) {
        console.log("carrier-list-grid:addOffer1", this.carrierID, this.originalQuoteOrderLineID, this.quoteOrderLineID, dataItem.offerId, this.editedCarrierList, dataItem);
        this.onCarrierClick.emit(dataItem.carrierId);
        //this.getCarrierDetailForOffer(dataItem.carrierId);

        if (dataItem.quoteOrderLineId == undefined) {
            dataItem.quoteOrderLineId = this.quoteOrderLineID;
        }
        else if (dataItem.quoteOrderLineId != undefined && dataItem.quoteOrderLineId == 0) {
            dataItem.quoteOrderLineId = this.quoteOrderLineID;
        }

        if (dataItem.offerId == null || dataItem.offerId == 0) {
            this.orderService.getOfferByLineIdCarrierId(dataItem.quoteOrderLineId, dataItem.carrierId).subscribe(result => {
                if (result != null) {
                    // Offer already exists
                    this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
                }
                else {
                    this.editedCarrierList = Object.assign({}, dataItem);
                    this.carrierID = this.editedCarrierList!.carrierId;
                    this.tabStrip.selectTab(2);
                }
                console.log("carrier-list-grid:addOffer2", this.carrierID, this.originalQuoteOrderLineID, this.quoteOrderLineID, dataItem.offerId, this.editedCarrierList, dataItem);
            });
        }
        else {
            this.editedCarrierList = Object.assign({}, dataItem);
            this.carrierID = this.editedCarrierList!.carrierId;
            this.tabStrip.selectTab(2);
            console.log("carrier-list-grid:addOffer3", this.carrierID, this.originalQuoteOrderLineID, this.quoteOrderLineID, dataItem.offerId, this.editedCarrierList, dataItem);
        }
    }

    public addSecondaryOffer(dataItem) {
        if (this.utilService.isLoading == true) {
            return;
        }
        this.utilService.isLoading = true;
        //console.log("carrier-list-grid:addSecondaryOffer:START"
        //    , "this.originalQuoteOrderLineID", this.originalQuoteOrderLineID
        //    , "this.carrierID", this.carrierID
        //    , "this.carrierOfferBatchID", this.carrierOfferBatchID
        //    , "this.editedCarrierList!.carrierOfferBatchId", this.editedCarrierList!.carrierOfferBatchId
        //    , "dataItem.offerId", dataItem.offerId
        //    , "dataItem.carrierID", dataItem.carrierID
        //    , "this.editedCarrierList", this.editedCarrierList
        //    , "dataItem", dataItem);
        this.quoteOrderLineID = dataItem.quoteOrderLineID;
        this.onCarrierClick.emit(this.carrierID);
        this.getCarrierDetailForOffer(this.carrierID);

        if (!dataItem.offerId || dataItem.offerId == 0) {
            this.orderService.getOfferByLineIdCarrierId(dataItem.quoteOrderLineID, this.carrierID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result != null) {
                    // Offer already exists
                    this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
                }
                else {
                    //this.editedCarrierList = Object.assign({}, dataItem);
                    //this.carrierID = this.editedCarrierList!.carrierId;
                    //this.quoteOrderLineID = dataItem.quoteOrderLineID;
                    this.getQuoteOrderLine();
                    this.onCarrierChange(this.carrierID);
                    //this.getCarrierOfferFromCarrier();
                    if (this.tabNum != 2) {
                        this.tabStrip.selectTab(2);
                    }
                }
            //    console.log("carrier-list-grid:addSecondaryOffer:no OfferID"
            //        , "this.originalQuoteOrderLineID", this.originalQuoteOrderLineID
            //        , "this.carrierID", this.carrierID
            //        , "this.carrierOfferBatchID", this.carrierOfferBatchID
            //        , "this.editedCarrierList!.carrierOfferBatchId", this.editedCarrierList!.carrierOfferBatchId
            //        , "dataItem.offerId", dataItem.offerId
            //        , "dataItem.carrierID", dataItem.carrierID
            //        , "this.editedCarrierList", this.editedCarrierList
            //        , "dataItem", dataItem);
            });
        }
        else {
            //this.editedCarrierList = Object.assign({}, dataItem);
            //this.carrierID = this.editedCarrierList!.carrierId;
            //this.quoteOrderLineID = dataItem.quoteOrderLineID;
            this.getQuoteOrderLine();
            this.onCarrierChange(this.carrierID);
            //this.getCarrierOfferFromCarrier();
            if (this.tabNum != 2) {
                this.tabStrip.selectTab(2);
            }
        //    console.log("carrier-list-grid:addSecondaryOffer:existing OfferID"
        //        , "this.originalQuoteOrderLineID", this.originalQuoteOrderLineID
        //        , "this.carrierID", this.carrierID
        //        , "this.carrierOfferBatchID", this.carrierOfferBatchID
        //        , "this.editedCarrierList!.carrierOfferBatchId", this.editedCarrierList!.carrierOfferBatchId
        //        , "dataItem.offerId", dataItem.offerId
        //        , "dataItem.carrierID", dataItem.carrierID
        //        , "this.editedCarrierList", this.editedCarrierList
        //        , "dataItem", dataItem);
        }
    }

    public cancelHandler({ sender, rowIndex }) {
        this.editedCarrierList = {} as CarrierList;
        this.closeEditor(sender, rowIndex);
        this.onCarrierClick.emit(0);
    }

    public cancelOffer() {
        //this.cancelHandler({ sender: this.carriersGrid, rowIndex: this.editedRowIndex });
        this.editedCarrierList = {} as CarrierList;
        this.carrierOfferBatchID = -1;
        if (this.originalQuoteOrderLineID > 0) {
            //this.carrier = {} as SearchCarrier;
            //this.carrierOffer = {} as CarrierList;
            this.quoteOrderLineID = this.originalQuoteOrderLineID;
            this.getQuoteOrderLine();
        }
        this.originalQuoteOrderLineID = 0;
        //this.closeEditor(this.carriersGrid, this.editedRowIndex);
        //this.tabStrip.selectTab(0);
        this.onCarrierClick.emit(0);
        this.updateEditedLoad.emit(this.originalLoad);
        //console.log("cancelOffer:originalLoad", this.originalQuoteOrderLineID, this.originalLoad);
        this.originalLoad = {} as SearchCarrierSalesAvailableLoads;
        this.tabStrip.selectTab(0);
    }

    public saveHandler({ sender, rowIndex, dataItem, isNew }) {
        //var carrier: CarrierList = dataItem as CarrierList;
        this.saveCarrierFromGrid(dataItem, true, false);
        sender.closeRow(rowIndex);
        this.onCarrierClick.emit(0);
        this.editedRowIndex = undefined;
        //this.editedCarrierList = undefined;
    }

    public saveOffer(isContinueMultiLoad: boolean) {
        this.isSaving = true;
        console.log("saveOffer", this.editedCarrierList);
        if (this.isBulkTender == true) {
            this.saveCarrierBulkTender();
        }
        else {
            //if (this.originalQuoteOrderLineID == 0) {
            //    this.originalQuoteOrderLineID = this.editedCarrierList!.quoteOrderLineId;
            //    this.editedCarrierList!.originalQuoteOrderLineID = this.editedCarrierList!.quoteOrderLineId;
            //}
            if (this.editedCarrierList!.carrierLaneId == 0 || this.editedCarrierList!.carrierLaneId == null) {
                this.saveNewCarrierLaneOffer(isContinueMultiLoad);
            }
            else {
                //this.saveHandler({ sender: this.carriersGrid, rowIndex: this.editedRowIndex, dataItem: this.editedCarrierList, isNew: false });
                this.saveCarrierFromGrid(this.editedCarrierList!, true, isContinueMultiLoad);
                var idx = this.carriers.findIndex(c => c.carrierId == this.editedCarrierList!.carrierId);
                if (idx >= 0) {
                    this.carriers[idx] = this.editedCarrierList!;
                    this.setGrid();
                }
                //this.editedCarrierList = undefined;
                //this.onCarrierClick.emit(0);
            }
        }
        console.log("carrier-list-grid:saveOffer", this.originalQuoteOrderLineID, this.carrierOfferBatchID, this.editedCarrierList);
    }

    private saveCarrierBulkTender() {
        this.getCarrierListFromBulkTender();
        this.cseService.saveOfferFromBulkTenderCarrierList(this.bulkTenderCarrierList).subscribe(result => {
            this.isSaving = false;
            console.log("saveCarrierBulkTender", result);
            if (result.length > 0 && result[0].offerId == 0) {
                // Offer already exists
                this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
            }
            else {
                for (var i = 0; i < result.length; i++) {
                    var idx = this.bulkTenderCarrierList.findIndex(t => t.quoteOrderLineId == result[i].quoteOrderLineId);
                    if (idx >= 0) {
                        this.bulkTenderCarrierList[idx].offerId = result[i].offerId;
                        //carrier.offerId = result.offerId;
                    }
                }
                this.onBulkTenderOfferSave.emit(result[0].offerBatchId);
            }
            //this.cseService.getOffersByLineId(this.quoteOrderLineID);
            //this.tabStrip.selectTab(4);
            // Go straight to award form
        }, error => {
            var ok = error;
        });
    }

    private saveCarrierFromGrid(carrier: CarrierList, isSaveAndEmail: boolean, isContinueMultiLoad: boolean) {
        carrier.originalQuoteOrderLineID = this.originalQuoteOrderLineID;
        if (isContinueMultiLoad && this.carrierOfferBatchID < 0) {
            // First time clicking Save & Continue needs to start a new batch
            this.carrierOfferBatchID = 0;
            carrier.carrierOfferBatchId = 0;
        }
        else if (isContinueMultiLoad && this.carrierOfferBatchID >= 0) {
            // Reuse batch after it was created for sub-offers when clicking Save & Continue
            carrier.carrierOfferBatchId = this.carrierOfferBatchID;
        }
        else if (!isContinueMultiLoad && this.carrierOfferBatchID >= 0) {
            // Reuse batch for last sub-offer when clicking Save
            carrier.carrierOfferBatchId = this.carrierOfferBatchID;
        }
        console.log("saveCarrierFromGrid", this.originalQuoteOrderLineID, this.carrierOfferBatchID, carrier);
        if (carrier.createdByEmployeeID == null || carrier.createdByEmployeeID == 0) {
            carrier.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
        if (isSaveAndEmail && carrier.emailed == true) {
            // Emailed selected, so pop up email form and include default carrier email
            this.sendCarrierEmail(carrier, false);
        }
        this.cseService.saveOfferFromCarrierList(carrier as CarrierList).subscribe(result => {
            this.isSaving = false;
            if (result.resultCollection[0].offerId == 0) {
                // Offer already exists
                this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
            }
            else {
                carrier.offerId = result.resultCollection[0].offerId;
                this.notificationService.showSuccess("Offer succesfully saved.", "SUCCESS: Offer Saved");
            }
            this.carrierOfferBatchID = result.resultCollection[0].carrierOfferBatchId;
            this.cseService.getOffersByLineId(this.quoteOrderLineID);
            if (!isContinueMultiLoad) {
                //console.log("saveCarrierFromGrid1:originalLoad", this.quoteOrderLineID, this.originalQuoteOrderLineID, this.originalLoad);
                this.carrierOfferBatchID = -1;
                this.carrier = {} as SearchCarrier;
                this.carrierOffer = {} as CarrierList;
                this.editedCarrierList = {} as CarrierList;

                this.quoteOrderLineID = this.originalQuoteOrderLineID;
                this.getQuoteOrderLine();
                this.updateEditedLoad.emit(this.originalLoad);
                this.refreshData.emit();
                //console.log("saveCarrierFromGrid2:originalLoad", this.quoteOrderLineID, this.originalQuoteOrderLineID, this.originalLoad);
                this.originalLoad = {} as SearchCarrierSalesAvailableLoads;
            }
            console.log("saveCarrierFromGrid", this.originalQuoteOrderLineID, this.carrierOfferBatchID, result);
            //this.cseService.getOffersByLineId(this.quoteOrderLineID).subscribe(offers => {
            //});
            //this.cseService.getOffersByLineId(this.quoteOrderLineID);
            //this.tabStrip.selectTab(0);
        }, error => {
            var ok = error;
        });
    }

    private closeEditor(grid, rowIndex = this.editedRowIndex) {
        grid.closeRow(rowIndex);
        this.resetLoad(this.editedCarrierList);
        this.editedRowIndex = undefined;
        this.editedCarrierList = {} as CarrierList;
    }

    private resetLoad(carrierList: CarrierList) {
        if (!carrierList) return;

        const originalLoad = this.carriers.find(item => item.carrierCode == carrierList.carrierCode)!;

        Object.assign(originalLoad, carrierList);
    }

    public sendCarrierEmail(carrier: CarrierList, isSaveAfterEmail: boolean) {
        var emailTo = "";
        var emailCC = "";
        var emailSubject = "Carrier Offer";
        var imageHtml = "<img style=\"height: 110px; width: 250px;\" src =\"http://alstracking.com/Content/Images/LOGO-TAG-MASTER-TRANSPARENT.png\"/>";

        //if (environment.production == true) {
            emailTo = carrier.defaultEmail;
        //}
        //else {
        //    emailTo = "aforbes@epilutions.com";
        //}

        var getCarrierContacts = this.contactService.getSearchContactByCarrierID(carrier.carrierId);
        var getEncryptedCarrier = this.encryptionService.getEncryptedValue(carrier.quoteOrderLineId + "|" + carrier.carrierId + "|" + carrier.contactId);
        var getEncryptedContact = this.encryptionService.getEncryptedValue(carrier.contactId + "");

        //this.encryptionService.getEncryptedValue(carrier.quoteOrderLineId + "|" + carrier.carrierId + "|" + carrier.contactId).subscribe(result => {
        //    encryptedCarrier = result;
        //});
        //this.encryptionService.getEncryptedValue(carrier.contactId + "").subscribe(result => {
        //    encryptedContact = result;
        //});

        forkJoin([getEncryptedCarrier, getEncryptedContact, getCarrierContacts]).subscribe(result => {
            var encryptedCarrier = result[0];
            var encryptedContact = result[1];
            var carrierContacts: SearchCarrierContact[] = result[2].resultCollection;
            this.ccEmails.length = 0;
            carrierContacts.forEach(c => {
                if (c.email != null && c.email != "") {
                //    if (environment.production == true) {
                        this.ccEmails.push({
                            name: c.contactName + " <" + c.email + ">",
                            email: c.email
                        });
                //    }
                //    else {
                //        var concat = (this.ccEmails.length > 0 ? this.ccEmails.length : "");
                //        this.ccEmails.push({
                //            name: c.contactName + " <corey@epilutions.com>",
                //            email: "corey" + concat + "@epilutions.com"
                //        });
                //    }
                }
            });

            var carrierUrl = this.baseUrl + "#/carrier-offer/" + encodeURIComponent(encryptedCarrier);
            var emailBody = "<p>Please click <a href='" + carrierUrl + "'>here</a> to add an offer or decline the load. ";
            emailBody += "Or reply to this email with your MC # and desired rate.</p>";
            emailBody += "<p>If you wish to unsubscribe from these reminders please click ";
            emailBody += "<a href='" + this.baseUrl + "/#/contact-unsubscribe/" + encodeURIComponent(encryptedContact) + "'>here</a></p>";
            emailBody += "<br/><br/>" + imageHtml;
            //console.log("sendCarrierEmail", emailBody);

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                showEmailBody: false,
                //contacts: contacts,
                emailTo: emailTo,
                emailCC: emailCC,
                ccEmails: this.ccEmails,
                emailSubject: emailSubject,
                emailBody: emailBody
            }

            const dialogRef = this.dialog.open(SendEmailDialog, dialogConfig);

            dialogRef.componentInstance.emailTo = emailTo;
            dialogRef.componentInstance.emailCC = emailCC;
            dialogRef.componentInstance.ccEmails = this.ccEmails;
            dialogRef.componentInstance.emailSubject = emailSubject;
            dialogRef.componentInstance.emailBody = emailBody;
            //console.log("dialogRef", dialogRef);

            dialogRef.afterClosed().subscribe(result => {
                if (result.btnOK == true) {
                    if (result == null ||
                        ((result.emailTo == null || result.emailTo.length < 1) &&
                            (result.emailSubject == null || result.emailSubject < 1))) return;
                    if (this.ccEmails.length > 0) {
                        var ccList = this.ccEmails.map(c => c.email).join(",");
                        result.emailCC = ccList;
                    }

                    //console.log("dialogRef.afterClosed()", result);

                    this.emailService.sendEmail(result.emailTo, result.emailCC, "", 0, result.emailSubject, result.emailBody).subscribe(emailResult => {
                        var ok = emailResult;
                        //console.log(result, emailResult);
                        if (isSaveAfterEmail == true && carrier.emailed != true) {
                            carrier.emailed = true;
                            carrier.contacted = true;
                            this.saveCarrierFromGrid(carrier, false, false);
                        }
                    });
                }
            });
        });
    }

    //private ccEmailsFilter: any[] = [];

    //public ccEmailsFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    //    this.ccEmailsFilter.splice(0, this.ccEmailsFilter.length, ...flatten(filter).map(({ value }) => value));
    //    //console.log("carrierRepsFilters", filter, this.carrierRepsFilter);
    //    return this.ccEmailsFilter;
    //}
    public ccEmailsChange(evt: any) {
        this.ccEmails = Array.from(evt);
        console.log(evt, this.ccEmails);
    }

    public onCarrierChange(evt: any) {
        //this.carrierOfferBatchID = 0;
        //this.originalQuoteOrderLineID = 0;

        //this.checkCarrierLookupValue();
        //var checkCallCity = this.cityControl.value;
        var selectedCarrier = this.carrierFormGroup.controls['carrierLookupControl'].value as CarrierLookup;

        var carrierID: number = 0;
        if (!isNaN(evt) && evt != null) {
            carrierID = evt;
        }
        else {
            carrierID = selectedCarrier.carrierID;
        }
        this.carrierID = carrierID;

        var customerCarriers = this.customerCarrierExclusionMapList.filter(r => r.carrierID == carrierID);
        if (customerCarriers.length > 0) {
            this.isCustomerExcluded = true;
        }
        else {
            this.isCustomerExcluded = false;
        }

        this.onCarrierClick.emit(carrierID);
        //console.log("carrier-list-grid:onCarrierChange", this.originalQuoteOrderLineID, evt, selectedCarrier);

        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierByCarrierID(carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            this.isAddCarrier = false;
            this.carrier = result.resultCollection[0];
            console.log("onCarrierChange", this.carrier, result);
            if (this.carrier != null) {
                this.getCarrierOfferFromCarrier();
            }
        });
        //if (selectedCarrier == null) return;
    }

    private getCarrierListFromBulkTender() {
        //var carrierListItem: CarrierList = this.getCarrierListItem();
        for (var i = 0; i < this.bulkTenderLoads.length; i++) {
            var carrierListItem: CarrierList = Object.assign({}, this.editedCarrierList!);
            var load: SearchCarrierSalesAvailableLoads = Object.assign({}, this.bulkTenderLoads[i]);
            carrierListItem.quoteOrderLineId = load.quoteOrderLineID;
            //carrierListItem.carrierLaneId = load.carrierLaneID;
            carrierListItem.miles = load.miles;
            carrierListItem.contacted = true;
            carrierListItem.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.bulkTenderCarrierList.push(carrierListItem);
        }
        //console.log("getCarrierListFromBulkTender", this.bulkTenderLoads, this.bulkTenderCarrierList);
    }

    private getCarrierListItem() {
        var carrierListItem: CarrierList | undefined;
        carrierListItem = this.carriersOrig.find(c => c.carrierId == this.carrier.carrierID);
        if (carrierListItem) {
            //this.carrierOffer = carrierListItem;
            return carrierListItem;
            //this.editedCarrierList = carrierListItem;
        }
        else {
            return {
                quoteOrderLineId: this.quoteOrderLineID,
                carrierId: this.carrier.carrierID,
                carrierCode: this.carrier.carrierCode,
                carrierName: this.carrier.carrierName,
                mcNumber: this.carrier.mcNumber,
                dotNumber: this.carrier.dotNumber,
                scacCode: this.carrier.scacCode,
                originZip3: '',
                destinationZip3: '',
                procurements: 0,
                carrierCity: this.carrier.carrierCity,
                carrierState: this.carrier.carrierState,
                defaultEmail: this.carrier.defaultEmail,
                contactId: this.carrier.contactID,
                modeId: 0,
                trailerTypeId: 0,
                matches: 0,
                miles: this.quoteOrderLine.miles,
                originStateId: 0,
                originMarketId: 0,
                originRegionId: 0,
                destinationStateId: 0,
                destinationMarketId: 0,
                destinationRegionId: 0,
                preferred: false,
                confidenceRanking: 0,
                source: '',
                ratePerMile: 0,
                lastRan: new Date(),
                offerId: 0,
                carrierLaneId: 0,
                lastOfferRate: 0,
                lastOfferDate: new Date(),
                offerRate: 0,
                offerRatePerMile: 0,
                minRate: 0,
                minRateDate: new Date(),
                carrierStatusRowColor: this.carrier.carrierStatusRowColor,
                extendedRate: 0,
                emailed: false,
                declined: false,
                contacted: false,
                awarded: false,
                commentID: 0,
                commentText: "",
                createdByEmployeeID: 0,
                carrierTeam: this.carrier.carrierTeam,
                rmisCertifiedColor: this.carrier.rmisCertifiedColor,
                rmisPotentialCarrierColor: this.carrier.rmisPotentialCarrierColor,
                rmisStatus: this.carrier.rmisStatus,
                nonCertifiedReasons: this.carrier.nonCertifiedReasons,
                rmisStatusColor: this.carrier.rmisStatusColor,
                rmisStatusTextColor: this.carrier.rmisStatusTextColor,
                rmisStatusAbbrev: this.carrier.rmisStatusAbbrev,
                rmisLastPotentialDate: this.carrier.rmisLastPotentialDate,
                isRMISCertified: this.carrier.isRMISCertified,
                carrierIncidents: this.carrier.carrierIncidents,
                lastCarrierIncidentDate: this.carrier.lastCarrierIncidentDate
            } as CarrierList;
        }
    }

    private getCarrierOfferFromCarrier() {
        this.editedCarrierList = this.getCarrierListItem();
        this.editedCarrierList.originalQuoteOrderLineID = this.originalQuoteOrderLineID;
        this.editedCarrierList.carrierOfferBatchId = this.carrierOfferBatchID;
        if (this.originalQuoteOrderLineID != this.quoteOrderLineID) {
            this.editedCarrierList.quoteOrderLineId = this.quoteOrderLineID;
            this.editedCarrierList.carrierLaneId = 0;
            this.editedCarrierList.miles = this.quoteOrderLine.miles;
            this.editedCarrierList.offerRate = 0;
            this.editedCarrierList.offerRatePerMile = 0;
            this.editedCarrierList.commentID = 0;
            this.editedCarrierList.commentText = "";
        }
        //console.log("getCarrierOfferFromCarrier", this.carrierID, this.originalQuoteOrderLineID, this.quoteOrderLineID, this.editedCarrierList);
    }

    public saveNewCarrierLaneOffer(isContinueMultiLoad: boolean) {
        console.log("saveNewCarrierLaneOffer", this.originalQuoteOrderLineID, this.carrierOfferBatchID, this.editedCarrierList, this.quoteOrderLine);
        this.utilService.isLoading = true;
        if (isContinueMultiLoad && this.carrierOfferBatchID < 0) {
            // First time clicking Save & Continue needs to start a new batch
            this.carrierOfferBatchID = 0;
            this.editedCarrierList!.carrierOfferBatchId = 0;
        }
        else if (isContinueMultiLoad && this.carrierOfferBatchID >= 0) {
            // Reuse batch after it was created for sub-offers when clicking Save & Continue
            this.editedCarrierList!.carrierOfferBatchId = this.carrierOfferBatchID;
        }
        else if (!isContinueMultiLoad && this.carrierOfferBatchID >= 0) {
            // Reuse batch for last sub-offer when clicking Save
            this.editedCarrierList!.carrierOfferBatchId = this.carrierOfferBatchID;
        }
        this.cseService.getCarrierLaneByCarrierIDGeocodeLaneID(this.editedCarrierList!.carrierId, this.quoteOrderLine.geocodeLaneID, this.quoteOrderLineID).subscribe(result => {
            //console.log("carrierLane", result);
            this.utilService.isLoading = false;
            var lane: CarrierLane = result.resultCollection[0];
            if (lane.procurements == 0) {
                this.editedCarrierList!.source = "ZipToZip";
            }
            this.editedCarrierList!.carrierLaneId = lane.carrierLaneID;
            //this.editedCarrierList!.source = "";
            this.editedCarrierList!.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            //this.geocodeLaneID = this.quoteOrderLine.geocodeLaneID;

            if (this.editedCarrierList!.emailed == true) {
                // Emailed selected, so pop up email form an d include default carrier email
                this.sendCarrierEmail(this.editedCarrierList!, false);
            }
            this.utilService.isLoading = true;
            //var carrier: CarrierList = this.editedCarrierList! as CarrierList;
            //console.log("saveOfferFromCarrierList", this.editedCarrierList!);
            this.cseService.saveOfferFromCarrierList(this.editedCarrierList!).subscribe(result2 => {
                this.isSaving = false;
                this.utilService.isLoading = false;
                if (result2.resultCollection[0].offerId == 0) {
                    // Offer already exists
                    this.notificationService.showWarning("An offer already exists for this carrier lane.", "WARNING: Offer Exists");
                }
                else {
                    this.editedCarrierList!.offerId = result2.resultCollection[0].offerId;
                    this.notificationService.showSuccess("Offer succesfully saved.", "SUCCESS: Offer Saved");
                }
                this.carrierOfferBatchID = result2.resultCollection[0].carrierOfferBatchId;
                this.cseService.getOffersByLineId(this.quoteOrderLineID);
                if (!isContinueMultiLoad) {
                    this.carrierOfferBatchID = -1;
                    this.carrier = {} as SearchCarrier;
                    this.carrierOffer = {} as CarrierList;
                    this.editedCarrierList = {} as CarrierList;

                    this.quoteOrderLineID = this.originalQuoteOrderLineID;
                    this.getQuoteOrderLine();
                    this.updateEditedLoad.emit(this.originalLoad);
                    //console.log("saveNewCarrierLaneOffer:originalLoad", this.originalQuoteOrderLineID, this.originalLoad);
                    this.originalLoad = {} as SearchCarrierSalesAvailableLoads;
                }
                //this.tabStrip.selectTab(0);
            }, error => {
                var ok = error;
            });
        });
    }

    public loadClick(evt: any) {
        this.updateEditedLoad.emit(evt);
        this.addSecondaryOffer(evt);
        //console.log("carrier-list-grid:loadClick", evt);
    }
}
